import { lazy, Suspense } from 'react';
import { FullScreenLoading } from '@/features/auth/guards';

const Page = lazy(() => import('./pages/marketing-page').then((m) => ({ default: m.MarketingPage })));
const Unsub = lazy(() => import('./pages/unsubscribe-page').then((m) => ({ default: m.UnsubscribePage })));

export const MarketingRoute = () => (
  <Suspense fallback={<div role="status" aria-label="Carregando" className="skeleton h-40 w-full" />}>
    <Page />
  </Suspense>
);
export const UnsubscribeRoute = () => (
  <Suspense fallback={<FullScreenLoading />}>
    <Unsub />
  </Suspense>
);
